export default __webpack_public_path__ + "static/iot-632efe08a87beb5b555b8da69f8a529b.png";